import { connect } from 'react-redux'

import { getFormColorSettings } from '../selectors'

function InnerComponent({ WrappedComponent, ...rest }) {
  return <WrappedComponent {...rest} />
}

const ComponentWrapper = connect(state => ({
  ...getFormColorSettings(state),
}))(InnerComponent)

function withColorSetting(component) {
  return function WithColorComponent(props) {
    return <ComponentWrapper WrappedComponent={component} {...props} />
  }
}

export default withColorSetting
